import React, {useState, useEffect} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCircleCheck, faCircleDot, } from '@fortawesome/free-solid-svg-icons';
import { ApisProvider, ExtinctionData, ExtinctionVideoData, ItemsData} from '../components/feactures/dataProvider';
import { UXHelper, VideoLoader, ProgressBar, DamageBar, Paginator } from '../components/UXHelper';
import { ItemsHor, ItemsInv, BpItems, WorkshopItems, Heroes } from '../components/Items';
import './styles/inventory.css';
import { calculateItemStats } from '../components/feactures/dataIterator';
import { LayoutContainer } from './layouts/layout_bi_columns';
import {ModalNotify} from '../components/Modals';

const collectionName = ExtinctionData.collectionName;
 
export const Inventory = ({ userConnected, showLoader, closerLoader }) => {

  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }
  
  if(!userConnected){
    return (
        <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }

   return (
      <LayoutContainer>
        <div className='container_lobbies'>
          <div className='title_lobby'>
            <h2>Choose an Inventory</h2>
          </div>
          <div className='lobby_inventory'>
            <UXHelper title={'Suits'} url={"/inventory/suits"} video={"https://extinctionwars.com/assets/videos/visuals/menu-items/menu_item_suits.webm"}/>
            <UXHelper title={'Weapons'} url={"/inventory/weapons"} video={"https://extinctionwars.com/assets/videos/visuals/menu-items/menu_item_weapons.webm"}/>
            <UXHelper title={'Blueprints'} url={"/inventory/bperks"} video={"https://extinctionwars.com/assets/videos/visuals/menu-items/menu_item_suits.webm"}/>
            <UXHelper title={'Special Items'} url={"/inventory/special-items"} video={"https://extinctionwars.com/assets/videos/visuals/menu-items/menu_item_boxes.webm"}/>
          </div>
        </div>
      </LayoutContainer>
   )
}

export const InventorySW = ({userData, itemType, showLoader, closerLoader}) => {

  const [userAsset, setUserAsset] = useState();
  const [pageAct, setPageAct] = useState(1);
  const [loader, setLoader] = useState(false); // Incorporar Loader

  const [fNation, setFNation] = useState(false);
  const [matchNation, setMatchNation] = useState();
  const [fRarity, setFRarity] = useState(false);
  const [matchRarity, setMatchRarity] = useState();


  useEffect(() => {
    if(userData.isConnected){  
      loadAssets();

    }

    return () => {
      // Nothing to do
    };

  }, [pageAct, userData.isConnected, loader, itemType]);

  useEffect(() => {
    if(userData.isConnected){
      loadAssets();
    }

    return () => {
      setPageAct(1)
    };

  }, [fRarity, matchRarity, fNation, matchNation,]);

  const determineTitle = (x) => {
    if(x === 'suits'){
      return 'Suits';
    }
    else if(x === 'weapons'){
      return 'Weapons';
    }
  }
  
  const pageTitle = determineTitle(itemType);

  const loadAssets = async() => {
      if(fNation && fRarity){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Nation=${matchNation}&data.Rarity=${matchRarity}&limit=20&order=desc&sort=asset_id`;

        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
      }
      else if(fRarity){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Rarity=${matchRarity}&limit=20&order=desc&sort=asset_id`;

        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
      }else if(fNation){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Nation=${matchNation}&limit=20&order=desc&sort=asset_id`;

        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
      }
      else{
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&limit=20&order=desc&sort=asset_id`;

        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
      }
  }

  const filterRarityCapture = (evt) => {
    const filter = evt.target.value;
    if(filter !== 'Select Rarity'){
      setMatchRarity(filter);
      setFRarity(true);
    }else{
      setFRarity(false);
    }
    
  }

  const filterNationCapture = (evt) => {
    const filter = evt.target.value;
    if(filter !== 'Select Nation'){
      setMatchNation(filter);
      setFNation(true);
    }else{
      setFNation(false);
    }
  }

  const clearFilters = () => {
    setFNation(false);
    setMatchNation('');
    setFRarity(false);
    setMatchRarity('');
  }

  const navigate = useNavigate();

  const PushUrl = (url) => {
    navigate(url);
  }

  const items = {
    visible: x => ({
      opacity: 1,
      y: 0,
      transition: { delay: x * 0.2, duration: 0.2 },
    }),
    initial: {
      y: '100px',
      opacity: 0,
    }
  }

  if(!userData.isConnected){
    return (
        <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }

  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }

return (
        <div className='inv_container'>
          <div className='top-controls-inv-selector'>
            <div className="row header-container">
              <div className="col p-0">
                <button onClick={() => PushUrl('/inventory')} className='backbtn'>Back</button>
              </div>
              <div className='col p-0'>
                <h1 className='title-inv'>{pageTitle} Inventory</h1>
              </div>
            </div>
            <div className='controls-section'>
                <div className='filters_sections'>
                  <select value={matchRarity} onChange={filterRarityCapture} className='filters-items-dual'>
                    <option defaultValue='Select Rarity'>Select Rarity</option>
                    <option value="Common">Common</option>
                    <option value="Rare">Rare</option>
                    <option value="Epic">Epic</option>
                    <option value="Legendary">Legendary</option>
                  </select>
                  <select value={matchNation} onChange={filterNationCapture} className='filters-items'>
                    <option defaultValue='Select Nation'>Select Nation</option>
                    <option value="Silkhs">Silkhs</option>
                    <option value="Arakneths">Arakneths</option>
                  </select>
                  {(fNation || fRarity)
                    ? <button onClick={() => clearFilters()} className='clear-filters'>Clear</button>
                    : <></>
                  }
                </div>
                <div className="page-container">
                  {pageAct > 1 &&
                    <button onClick={() => setPageAct(pageAct - 1)} className='btn-page'>Prev Page</button>            
                  }
                  <span className='page-ident'>{pageAct}</span>
                  <button onClick={() => setPageAct(pageAct + 1)} className='btn-page'>Next Page</button>
                </div>
            </div>
          </div>
          <div className='section-items'>
              {userAsset &&
              <>
                  {userAsset.map((a, x)=> (
                    <motion.div className='asset-box card-asset' key={a.asset_id} onClick={() => PushUrl(`/inventory/${itemType}/${a.asset_id}`)}
                    custom={x}
                    initial='initial'
                    animate='visible'
                    variants={items}
                    >
                      <ItemsInv itemP={a}/>
                    </motion.div>
                  ))}
              </>
              }
          </div>
      </div>
    )
}

export const InvBlueprints = ({ userData, itemType, showLoader, closerLoader}) => {

  const [userAsset, setUserAsset] = useState();
  const [pageAct, setPageAct] = useState(1);
  const [loader, setLoader] = useState(false); // Incorporar Loader

  const [fNation, setFNation] = useState(false);
  const [matchNation, setMatchNation] = useState();
  const [fType, setFType] = useState(false);
  const [matchType, setMatchType] = useState();

  useEffect(() => {
    if(userData.isConnected){
      loadAssets();
    }

    return () => {
      // Nothing to do
    };

}, [pageAct, loader, fType, matchType, fNation, matchNation, userData.isConnected]);

const loadAssets = async() => {
    
    if(fNation && fType){
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Type=${matchType}&data.Nation=${matchNation}&limit=20&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const assetsData = data.data;
      setUserAsset(assetsData);
    }
    else if(fType){
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Type=${matchType}&limit=20&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const assetsData = data.data;
      setUserAsset(assetsData);
    }else if(fNation){
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Nation=${matchNation}&limit=20&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const assetsData = data.data;
      setUserAsset(assetsData);
    }
    else{
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&limit=20&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const assetsData = data.data;
      setUserAsset(assetsData);
    }
}

const filterTypeCapture = (evt) => {
  const filter = evt.target.value;
  if(filter !== 'Select Type'){
    setMatchType(filter);
    setFType(true);
  }else{
    setFType(false);
  }
  
}

const filterNationCapture = (evt) => {
  const filter = evt.target.value;
  if(filter !== 'Select Nation'){
    setMatchNation(filter);
    setFNation(true);
  }else{
    setFNation(false);
  }
}

const clearFilters = () => {
  setFNation(false);
  setMatchNation('');
  setFType(false);
  setMatchType('');
}

const navigate = useNavigate();

const PushUrl = (url) => {
  navigate(url);
}

if(!userData.isConnected){
  return (
      <div className='signIn_box'>
          <h2 className='signIn-letter'>You need to sign in before!</h2>
      </div>
  )
}

if(showLoader){
  return (
    <div className='loader_animation'>
      <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
    </div>
  )
}

return (
        <div className='inv_container'>
          <div className='row top-controls-inv-selector'>
            <div className="row header-container">
              <div className="col p-0">
                <button onClick={() => PushUrl('/inventory')} className='backbtn'>Back</button>
              </div>
              <div className='col p-0'>
                <h1 className='title-inv'>Inventory Blueprints</h1>
              </div>
            </div>
            <div className='controls-section'>
                <div className='filters_sections'>
                  <select value={matchType} onChange={filterTypeCapture} className='filters-items-dual'>
                    <option defaultValue='Select Type'>Select Type</option>
                    <option value="Magazine">Magazine</option>
                    <option value="Barrel">Barrel</option>
                    <option value="Legs">Legs</option>
                    <option value="Helmet">Helmet</option>
                    <option value="Stock">Stock</option>
                    <option value="Arms">Arms</option>
                    <option value="BodyGun">BodyGun</option>
                    <option value="Chest">Chest</option>
                  </select>
                  {/* <select value={matchNation} onChange={filterNationCapture} className='filters-items'>
                    <option defaultValue='Select Nation'>Select Nation</option>
                    <option value="Silkhs">Silkhs</option>
                    <option value="Arakneths">Arakneths</option>
                  </select> */}
                  {(fNation || fType)
                    ? <button onClick={() => clearFilters()} className='clear-filters'>Clear</button>
                    : <></>
                  }
                </div>
                <Paginator pageAct={pageAct} setPageAct={setPageAct}/>
            </div>
          </div>
          <div className='section-items'>
              {userAsset &&
              <>
                  {userAsset.map((a)=> (
                      <div className='asset-box box-specials' key={a.asset_id}>
                        <BpItems id={a.asset_id}/>
                      </div>
                  ))}
              </>
              }
          </div>
      </div>
)
}

export const InventoryTeam = ({userData, itemType, onSelect}) => {

  const [userAsset, setUserAsset] = useState();
  const [pageAct, setPageAct] = useState(1);
  const [loadingData, setLoadingData] = useState(true);

  const [fNation, setFNation] = useState(false);
  const [matchNation, setMatchNation] = useState();
  const [fRarity, setFRarity] = useState(false);
  const [matchRarity, setMatchRarity] = useState();

  const [selector, setSelector] = useState();
  
  const {id} = useParams();
  const locationExpe = id;

  useEffect(() => {     
      
    loadAssets(locationExpe);

        return () => {
          //
      };

  }, [pageAct]);

  useEffect(() => {     
      
      loadAssets(locationExpe);

      return () => {
          setPageAct(1);
      };

  }, [fRarity, matchRarity, fNation, matchNation]);


  const loadAssets = async(id) => {
    if(Number(id) === 0 || Number(id) === 1){
      const nation = 'Silkhs';
      if(fRarity){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&data.Nation=${nation}&page=${pageAct}&data.Rarity=${matchRarity}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
        setTimeout(setLoadingData, 1000, false);
      }
      else{
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&data.Nation=${nation}&page=${pageAct}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
        setTimeout(setLoadingData, 1000, false);
      }
    }
    else if(Number(id) === 2 || Number(id) === 3){
      const nation = 'Arakneths';
      if(fRarity){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&data.Nation=${nation}&page=${pageAct}&data.Rarity=${matchRarity}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);

        setTimeout(setLoadingData, 1000, false);
      }
      else{
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&data.Nation=${nation}&page=${pageAct}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);

        setTimeout(setLoadingData, 1000, false);
      }
    }
    else if(Number(id) === 4 || Number(id) === 5){
      if(fNation && fRarity){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Nation=${matchNation}&data.Rarity=${matchRarity}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
        setTimeout(setLoadingData, 1000, false);
  
      }
      else if(fRarity){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Rarity=${matchRarity}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
        setTimeout(setLoadingData, 1000, false);
  
      }else if(fNation){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Nation=${matchNation}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
        setTimeout(setLoadingData, 1000, false);
      }
      else{
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
        setTimeout(setLoadingData, 1000, false);
      }
    }
    else if(Number(id) === 6 || Number(id) === 7){
      const nation = 'Training Camp';
      if(fRarity){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&data.Nation=${nation}&page=${pageAct}&data.Rarity=${matchRarity}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);

        setTimeout(setLoadingData, 1000, false);
      }
      else{
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${itemType}&owner=${userData.username}&data.Nation=${nation}&page=${pageAct}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);

        setTimeout(setLoadingData, 1000, false);
      }
    }
  }

    const filterRarityCapture = (evt) => {
      const filter = evt.target.value;
      if(filter !== 'Select Rarity'){
        setMatchRarity(filter);
        setFRarity(true);
      }else{
        setFRarity(false);
      }
      
    }
    
    const filterNationCapture = (evt) => {
      const filter = evt.target.value;
      if(filter !== 'Select Nation'){
        setMatchNation(filter);
        setFNation(true);
      }else{
        setFNation(false);
      }
    }
    
    const clearFilters = (id) => {
      if(Number(id) === 0 || Number(id) === 1){
        setFRarity(false);
        setMatchRarity('')
      }
      else if(Number(id) === 2 || Number(id) === 3){
        setFRarity(false);
        setMatchRarity('')
      }
      else{
        setFNation(false);
        setMatchNation('');
        setFRarity(false);
        setMatchRarity('');
      }
    }
  
  const selectorItem = (id) => {
    setSelector(id);
  }

  if(loadingData){
    return (
        <div className='loading-box'>
            <div className="spinner-border">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
  }

  if(Number(locationExpe) === 0 || Number(locationExpe) === 1 || Number(locationExpe) === 2 || Number(locationExpe) === 3 || Number(locationExpe) === 6 || Number(locationExpe) === 7){
    return (
      <div className='inv-exp'>
          <div className='controls-section inv-controls-sections-team'>
              <div className='filters_sections'>
                <select value={matchRarity} onChange={filterRarityCapture} className='filters-items'>
                  <option defaultValue='Select Rarity'>Select Rarity</option>
                  <option value="Common">Common</option>
                  <option value="Rare">Rare</option>
                  <option value="Epic">Epic</option>
                  <option value="Legendary">Legendary</option>
                </select>
                {(fRarity)
                  ? <button onClick={() => clearFilters(locationExpe)} className='clear-filters btn-ceditteam'>Clear</button>
                  : <></>
                }
              </div>
              <div className="page-container">
                {pageAct > 1 &&
                  <button onClick={() => setPageAct(pageAct - 1)} className='btn-page'>Prev Page</button>            
                }
                <span className='page-ident'>{pageAct}</span>
                <button onClick={() => setPageAct(pageAct + 1)} className='btn-page'>Next Page</button>
              </div>
          </div>
            <div className="items_container">
                {userAsset &&
                <>
                    {userAsset.map((a)=> (
                        <div key={a.asset_id} className='item_box'>
                          <ItemsHor itemP={a}>
                            {selector === a.asset_id
                              ? <button className='btn-selector-item item-selected'>Selected</button>
                              : <button onClick={(event) => {
                                event.preventDefault();
                                const itemId = a.asset_id;
                                selectorItem(itemId);
                                onSelect(itemType, itemId)}} className='btn-selector-item'>Select</button>
                            }
                          </ItemsHor>
                        </div>
                    ))}
                </>
                }
            </div>
        </div>
    )
  }

return (
        <div className='inv-exp'>
          <div className='controls-section inv-controls-sections-team'>
              <div className='filters_sections'>
                <select value={matchRarity} onChange={filterRarityCapture} className='filters-items-dual'>
                  <option defaultValue='Select Rarity'>Select Rarity</option>
                  <option value="Common">Common</option>
                  <option value="Rare">Rare</option>
                  <option value="Epic">Epic</option>
                  <option value="Legendary">Legendary</option>
                </select>
                <select value={matchNation} onChange={filterNationCapture} className='filters-items'>
                  <option defaultValue='Select Nation'>Select Nation</option>
                  <option value="Silkhs">Silkhs</option>
                  <option value="Arakneths">Arakneths</option>
                </select>
                {(fNation || fRarity)
                  ? <button onClick={() => clearFilters()} className='clear-filters btn-ceditteam'>Clear</button>
                  : <></>
                }
              </div>
              <div className="page-container">
                {pageAct > 1 &&
                  <button onClick={() => setPageAct(pageAct - 1)} className='btn-page'>Prev Page</button>            
                }
                <span className='page-ident'>{pageAct}</span>
                <button onClick={() => setPageAct(pageAct + 1)} className='btn-page'>Next Page</button>
              </div>
          </div>
            <div className="items_container">
                {userAsset &&
                <>
                    {userAsset.map((a)=> (
                        <div key={a.asset_id} className='item_box'>
                          <ItemsHor itemP={a}>
                            {selector === a.asset_id
                              ? <button className='btn-selector-item item-selected'>Selected</button>
                              : <button onClick={(event) => {
                                event.preventDefault();
                                const itemId = a.asset_id;
                                selectorItem(itemId);
                                onSelect(itemType, itemId)}} className='btn-selector-item'>Select</button>
                            }
                          </ItemsHor>
                        </div>
                    ))}
                </>
                }
            </div>
        </div>
)
}

export const ItemsDetails = ({ userData, pricesFees, onRefreshBalances, showLoader, closerLoader }) => {
  
  const {id} = useParams();
  const [loadingData, setLoadingData] = useState(true);
  const [refreshComp, setRefreshComp] = useState(false);  
  
  const [item, setItem] = useState({
    id: id,
    name: 'No item',
    nation: '',
    itemtype: '',
    power: '',
    rarity: '',
    img: '',
    damage: '',
    templateId: '',
  });

  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: '',
    msg: '',
    txId: '',
  })

  const [suitStatistics, setSuitStatistics] = useState({
    power: 0,
    wightLimit: 0,
    radiationRes: 0,
    energyC: 0,
})
const [weaponStatistics, setWeaponStatistics] = useState({
    power: 0,
    utility: 0,
    lethality: 0,
    attack: 0,
})
  
  const api = `${ApisProvider.atomicApi}atomicassets/v1/assets/${id}`;

  useEffect(() => {
    if(userData.isConnected){
      loadAsset();
    }

    return () => {
      // Nothing to do
    };
    
  }, [refreshComp, userData.isConnected]);

  const loadAsset = async() => {
    setRefreshComp(false);
    setItem({
      id: id,
      name: 'No item',
      nation: '',
      itemtype: '',
      power: '',
      rarity: '',
      img: '',
      damage: '',
      templateId: '',
  
    });
    setLoadingData(true);
      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const itemData = data.data;
      const rarity = itemData.data.Rarity;
      const power = itemData.data.Power;
      const itemType = itemData.schema.schema_name;
      const nation = itemData.data.Nation;

      const templateTarget = itemData.template.template_id;

      if(itemType === 'suits'){
        const data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateTarget));
            setItem({
              id: itemData.asset_id,
              name: data.name,
              nation: data.nation,
              power: data.power,
              rarity: data.rarity,
              img: data.img,
              type: itemData.schema.schema_name,
              damage: itemData.data.Expeditions,
              templateId: data.templateId,
            })
        

        const stats = calculateItemStats(rarity, power, itemType, nation);
        setSuitStatistics({
            power: power,
            wightLimit: stats.weightL,
            radiationRes: stats.radiationR,
            energyC: stats.energyC,
        })
      }
      else if(itemType === 'weapons'){

        const data = ItemsData.weapons.find(x => Number(x.templateId) === Number(templateTarget));
            setItem({
                id: itemData.asset_id,
                name: data.name,
                nation: data.nation,
                power: data.power,
                rarity: data.rarity,
                img: data.img,
                type: itemData.schema.schema_name,
                damage: itemData.data.Expeditions,
                templateId: data.templateId,

            })

          const stats = calculateItemStats(rarity, power, itemType, nation);
          setWeaponStatistics({
              power: power,
              utility: stats.utility,
              lethality: stats.lethality,
              attack: stats.attack,
          })
      }
      setTimeout(setLoadingData, 2000, false);
  }

  const repairItem = async(id) => {
    if(userData.whichProvider === 'Anchor'){
      try{
        const action = {
          account: ExtinctionData.ONYX_CONTRACT,
          name: 'repairnft',
          authorization: [userData.auths],
          data: {
            from: userData.username,
            to: ExtinctionData.EXTINCTION_CONTRACT,
            quantity: pricesFees.repairfee,
            itemid: id,
          },
        }
        userData.sessionData.transact({action}).then(({transaction}) => {
        //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          onRefreshBalances();
          setItem((state) => ({
            ...state,
            damage: '0',
          }));
        })
      }
      catch(err){
          
      }
    }
    else if(userData.whichProvider === 'WaxCloud'){
      try{
        const action = {
            actions: [{
                account: ExtinctionData.ONYX_CONTRACT,
                name: 'repairnft',
                authorization: [{
                    actor: userData.username,
                    permission: 'active',
                }],
                data: {
                  from: userData.username,
                  to: ExtinctionData.EXTINCTION_CONTRACT,
                  quantity: pricesFees.repairfee,
                  itemid: id,
                },
            }],
        }
        const transaction = await userData.sessionData.api.transact(action, {
            blocksBehind: 3,
            expireSeconds: 1200,
          });
          onRefreshBalances();
          setItem((state) => ({
            ...state,
            damage: '0',
          }));
          setNotify({
            status: true,
            error: false,
            title: 'Success',
            msg: 'Transaction Id:',
            txId: transaction.transaction_id,
          });
      }
      catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
      }
    }
  }

  const selectHero = async(asset_id) => {
    if(userData.whichProvider === 'Anchor'){
        try{
            const action = {
              account: ExtinctionData.EXTINCTION_CONTRACT,
              name: 'sethero',
              authorization: [userData.auths],
              data: {
                account: userData.username,
                asset_ids: [asset_id],
              },
            }
            userData.sessionData.transact({action}).then(({transaction}) => {
            //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            })
        }catch(err){
            
        }
    }
    else if(userData.whichProvider === 'WaxCloud'){
        try{
            const action = {
                actions: [{
                  account: ExtinctionData.EXTINCTION_CONTRACT,
                    name: 'sethero',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                      }],
                    data: {
                        account: userData.username,
                        asset_ids: [asset_id],
                      },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setNotify({
                status: true,
                error: false,
                title: 'Success',
                msg: 'Transaction Id:',
                txId: transaction.transaction_id,
              });
          }
          catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
          }
    }
  }

  const navigate = useNavigate();

  const BackUrl = () => {
    navigate(-1);
  }
  

  if(!userData.isConnected){
    return (
        <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }

  if(loadingData){
    return (
            <div className='loading-box'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
    )
  }

  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }

  if(Number(item.templateId) === Number(ExtinctionData.ID_DUMMY_WEAPON)){
    return (
      <LayoutContainer styles_element={{backgroundColor: '#191819'}}>
      <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
              {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                        setNotify({
                            status: false,
                            error: false,
                            title: '',
                            msg: '',
                            txId: '',
                        })
                      }}/>}
              </div>
      <div className='mb-3'>
        <button onClick={() => BackUrl()} className='backbtn'>Back</button>
      </div>
      <div className='item_container_detail'>
        <div className='item_preview'>
          <video src={item.img} autoPlay muted loop typeof='video/mp4' className='img_item_detail' alt={item.name}/>
          <span className='difuser_visual_item_detail'></span>
        </div>
        <div className='item_info_box'>
          <div className='header_titles_item_detail'>
            <h2 className={`title_name_item_detail `}>{item.name}</h2>
            <h4 className={`rarity_name_item_detail color-${item.rarity.split(" ").join("")}`}>{item.rarity}</h4>
          </div>
          <div className='info_box_effect_border_item_detail'>
            <div className='stats_performance_container_item_detail'>
              <span className='power_amount_item_detail'>{weaponStatistics.power}</span><span className='power_label_item_detail'>Power</span>
              <div className='box_performance_statistics'>
                  <div className='weight_stat'>
                      <span className='label_stat'>Utility</span>
                      <ProgressBar width={weaponStatistics.utility} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                  </div>
                  <div className='radiation_stat'>
                      <span className='label_stat'>Lethality</span>
                      <ProgressBar width={weaponStatistics.lethality} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                  </div>
                  <div className='firepower_stat'>
                      <span className='label_stat'>Attack</span>
                      <ProgressBar width={weaponStatistics.attack} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                  </div>
              </div>
              <div className='box_damage_item_detail'>
                <span>Integrity</span>
                <DamageBar damage={item.damage} templateid={item.templateId} height={'15px'}/>
              </div>
              <div className=''>
                <div className=''>
                  <div>
                    <span className='title_awards_achie_item_detail'>achievements</span>
                  </div>
                  <div className='builder_awards_achievements_item_detail'>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                  </div>
                </div>
                <div>
                  <div>
                    <span className='title_awards_achie_item_detail'>awards</span>
                  </div>
                  <div className='builder_awards_achievements_item_detail'>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                  </div>
                </div>
              </div>
            </div>
            <div className='box_actions_item_detail'>
                {/* <button className='btn_item_detail_action' onClick={() => {
                  if(Number(item.damage) === 30){
                    repairItem(item.id)
                  }}}>Repair Item</button> */}
            </div>
          </div>
        </div>
      </div>
    </LayoutContainer>
    )
  }

  if(item.type === 'weapons'){
    return (
    <LayoutContainer styles_element={{backgroundColor: '#191819'}}>
      <div  style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
              {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                        setNotify({
                            status: false,
                            error: false,
                            title: '',
                            msg: '',
                            txId: '',
                        })
                      }}/>}
              </div>
      <div className='mb-3'>
        <button onClick={() => BackUrl()} className='backbtn'>Back</button>
      </div>
      <div className='item_container_detail'>
        <div className='item_preview'>
          <video src={item.img} autoPlay muted loop typeof='video/mp4' className='img_item_detail' alt={item.name}/>
          <span className='difuser_visual_item_detail'></span>
        </div>
        <div className='item_info_box'>
          <div className='header_titles_item_detail'>
            <h2 className={`title_name_item_detail `}>{item.name}</h2>
            <h4 className={`rarity_name_item_detail color-${item.rarity.split(" ").join("")}`}>{item.rarity}</h4>
          </div>
          <div className='info_box_effect_border_item_detail'>
            <div className='stats_performance_container_item_detail'>
              <span className='power_amount_item_detail'>{weaponStatistics.power}</span><span className='power_label_item_detail'>Power</span>
              <div className='box_performance_statistics'>
                  <div className='weight_stat'>
                      <span className='label_stat'>Utility</span>
                      <ProgressBar width={weaponStatistics.utility} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                  </div>
                  <div className='radiation_stat'>
                      <span className='label_stat'>Lethality</span>
                      <ProgressBar width={weaponStatistics.lethality} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                  </div>
                  <div className='firepower_stat'>
                      <span className='label_stat'>Attack</span>
                      <ProgressBar width={weaponStatistics.attack} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                  </div>
              </div>
              <div className='box_damage_item_detail'>
                <span>Integrity</span>
                <DamageBar damage={item.damage} height={'15px'}/>
              </div>
              <div className=''>
                <div className=''>
                  <div>
                    <span className='title_awards_achie_item_detail'>achievements</span>
                  </div>
                  <div className='builder_awards_achievements_item_detail'>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                  </div>
                </div>
                <div>
                  <div>
                    <span className='title_awards_achie_item_detail'>awards</span>
                  </div>
                  <div className='builder_awards_achievements_item_detail'>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                  </div>
                </div>
              </div>
            </div>
            <div className='box_actions_item_detail'>
                <button className='btn_item_detail_action' onClick={() => {
                  if(Number(item.damage) === 30){
                    repairItem(item.id)
                  }}}>Repair Item</button>
            </div>
          </div>
        </div>
      </div>
    </LayoutContainer>
    )
  }

  if(Number(item.templateId) === Number(ExtinctionData.ID_DUMMY_SUIT)){
    return (
      <LayoutContainer styles_element={{backgroundColor: '#191819'}}>
      <div  style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
              {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                        setNotify({
                            status: false,
                            error: false,
                            title: '',
                            msg: '',
                            txId: '',
                        })
                      }}/>}
              </div>
      <div className='mb-3'>
        <button onClick={() => BackUrl()} className='backbtn'>Back</button>
      </div>
      <div className='item_container_detail'>
        <div className='item_preview'>
          <video src={item.img} autoPlay muted loop typeof='video/mp4' className='img_item_detail' alt={item.name}/>
          <span className='difuser_visual_item_detail'></span>
        </div>
        <div className='item_info_box'>
          <div className='header_titles_item_detail'>
            <h2 className={`title_name_item_detail `}>{item.name}</h2>
            <h4 className={`rarity_name_item_detail color-${item.rarity.split(" ").join("")}`}>{item.rarity}</h4>
          </div>
          <div className='info_box_effect_border_item_detail'>
            <div className='stats_performance_container_item_detail'>
              <span className='power_amount_item_detail'>{suitStatistics.power}</span><span className='power_label_item_detail'>Power</span>
              <div className='box_performance_statistics'>
                  <div className='weight_stat'>
                      <span className='label_stat'>Weight Limit</span>
                      <ProgressBar width={suitStatistics.wightLimit} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                  </div>
                  <div className='radiation_stat'>
                      <span className='label_stat'>Radiation Resistance</span>
                      <ProgressBar width={suitStatistics.radiationRes} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                  </div>
                  <div className='firepower_stat'>
                      <span className='label_stat'>Energy Cost</span>
                      <ProgressBar width={suitStatistics.energyC} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                  </div>
              </div>
              <div className='box_damage_item_detail'>
                <span>Integrity</span>
                <DamageBar damage={item.damage} templateid={item.templateId} height={'15px'}/>
              </div>
              <div className=''>
                <div className=''>
                  <div>
                    <span className='title_awards_achie_item_detail'>achievements</span>
                  </div>
                  <div className='builder_awards_achievements_item_detail'>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                  </div>
                </div>
                <div>
                  <div>
                    <span className='title_awards_achie_item_detail'>awards</span>
                  </div>
                  <div className='builder_awards_achievements_item_detail'>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                    <div className='achievements_item'></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='box_actions_item_detail'>
              {/* <button className='btn_item_detail_action' onClick={() => {
                if(Number(item.damage) === 5){
                  repairItem(item.id)
                }}}>Repair Item</button>
                <button className='btn_item_detail_action' onClick={() => {
                  selectHero(item.id);
                }}>Select As Hero</button> */}
          </div>
        </div>
      </div>
    </LayoutContainer>
    )
  }

  return (
          <LayoutContainer styles_element={{backgroundColor: '#191819'}}>
            <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
              {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                        setNotify({
                            status: false,
                            error: false,
                            title: '',
                            msg: '',
                            txId: '',
                        })
                      }}/>}
              </div>
            
            <div className='mb-3'>
              <button onClick={() => BackUrl()} className='backbtn'>Back</button>
            </div>
            
            <div className='item_container_detail'>
              <div className='item_preview'>
                <video src={item.img} autoPlay muted loop typeof='video/mp4' className='img_item_detail' alt={item.name}/>
                <span className='difuser_visual_item_detail'></span>
              </div>
              <div className='item_info_box'>
                <div className='header_titles_item_detail'>
                  <h2 className={`title_name_item_detail `}>{item.name}</h2>
                  <h4 className={`rarity_name_item_detail color-${item.rarity.split(" ").join("")}`}>{item.rarity}</h4>
                </div>
                <div className='info_box_effect_border_item_detail'>
                  <div className='stats_performance_container_item_detail'>
                    <span className='power_amount_item_detail'>{suitStatistics.power}</span><span className='power_label_item_detail'>Power</span>
                    <div className='box_performance_statistics'>
                        <div className='weight_stat'>
                            <span className='label_stat'>Weight Limit</span>
                            <ProgressBar width={suitStatistics.wightLimit} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                        </div>
                        <div className='radiation_stat'>
                            <span className='label_stat'>Radiation Resistance</span>
                            <ProgressBar width={suitStatistics.radiationRes} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                        </div>
                        <div className='firepower_stat'>
                            <span className='label_stat'>Energy Cost</span>
                            <ProgressBar width={suitStatistics.energyC} height={'5px'} colorUp={'#fff515'} colorDown={'#3f354c'}/>
                        </div>
                    </div>
                    <div className='box_damage_item_detail'>
                      <span>Integrity</span>
                      <DamageBar damage={item.damage} height={'15px'}/>
                    </div>
                    <div className=''>
                      <div className=''>
                        <div>
                          <span className='title_awards_achie_item_detail'>achievements</span>
                        </div>
                        <div className='builder_awards_achievements_item_detail'>
                          <div className='achievements_item'></div>
                          <div className='achievements_item'></div>
                          <div className='achievements_item'></div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <span className='title_awards_achie_item_detail'>awards</span>
                        </div>
                        <div className='builder_awards_achievements_item_detail'>
                          <div className='achievements_item'></div>
                          <div className='achievements_item'></div>
                          <div className='achievements_item'></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='box_actions_item_detail'>
                    <button className='btn_item_detail_action' onClick={() => {
                      if(Number(item.damage) === 30){
                        repairItem(item.id)
                      }}}>Repair Item</button>
                      <button className='btn_item_detail_action' onClick={() => {
                        selectHero(item.id);
                      }}>Select As Hero</button>
                </div>
              </div>
            </div>
          </LayoutContainer>
  )
}

export const InventoryParts = ({userData, type, part, melee, onSelect, closer , itemChecker, moduleType}) => {

  const [userAsset, setUserAsset] = useState();
  const [pageAct, setPageAct] = useState(1);
  const [loadingData, setLoadingData] = useState(true);

  const [errorMessage, setErrorMessage] = useState({
    status: false,
    message: '',
    itemCorrect: '',
  });
  const [meleeFilter, setMeleeFilter] = useState(false);
  

  useEffect(() => {     
      
    loadAssets(type);

        return () => {
          //
      };

  }, [pageAct]);

  useEffect(() => {     
      
    loadAssets(type);

        return () => {
          setPageAct(1)
      };

  }, [meleeFilter]);

  const loadAssets = async(schemaId) => {
      if(meleeFilter === true){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${schemaId}&owner=${userData.username}&data.Type=${melee}&page=${pageAct}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
        setTimeout(setLoadingData, 1000, false);
      }
      else{
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${schemaId}&owner=${userData.username}&data.Type=${part}&page=${pageAct}&limit=6&order=desc&sort=asset_id`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
        setTimeout(setLoadingData, 1000, false);
      }
  }

  const itemSelector = (id, itemName, part) => {
    if(moduleType === 'suit'){
      if(itemChecker.isBuilding){
        if(itemName === itemChecker.nameBuilding){
          onSelect(id, part);
        }
        else{
          setErrorMessage({
            status: true,
            message: 'The selected part must belong to the same suit.', 
            itemCorrect: itemChecker.nameBuilding,
          })
        }
      }else{
        onSelect(id, part);
      }
    }
    else if(moduleType === 'weapon'){
      if(itemChecker.isBuilding){
        if(itemName === itemChecker.nameBuilding){
          onSelect(id, part);
        }else{
          setErrorMessage({
            status: true,
            message: 'The selected part must belong to the same weapon.', 
            itemCorrect: itemChecker.nameBuilding,
          })
        }
      }else{
        onSelect(id, part);
      }
    }
    
  }

  const meeleWeaponsToggler = () => setMeleeFilter(!meleeFilter);
  const errorModuleCloser = () => setErrorMessage({
    status: false,
    message: '',
    itemCorrect: '',
  })

  if(errorMessage.status){
    return(
      <div className='inventory_main_container_blueprints'>
          <div className='inventory_modal_box'>
            <div className='header_container'>
              <div className='closer_title_row'>
                <h2 className='inventory_title_bp'>select {part}</h2>
                <button className='btn_ close' onClick={() => closer()}><FontAwesomeIcon icon={faXmark}/></button>
              </div>
            </div>
            <div className='error_container'>
              <h3>{errorMessage.message}</h3>
              <h1>Escoge las piezas del: <span style={{color: 'red'}}>{errorMessage.itemCorrect}</span></h1>
              <button onClick={() => errorModuleCloser()}>Retry</button>
            </div>
          </div>  
        </div>
    )
  }

  if(melee){
    return (
      <div className='inventory_main_container_blueprints'>
          <div className='inventory_modal_box'>
            <div className='header_container'>
              <div className='closer_title_row'>
                <h2 className='inventory_title_bp'>select {part}</h2>
                <button className='btn_ close' onClick={() => closer()}><FontAwesomeIcon icon={faXmark}/></button>
              </div>
              <div className='page_controllers_container_bp'>
                <div className='filter_container_bp'>
                  {meleeFilter
                    ? <button className='btn_melee_bp hide_meele_weapons_bp' onClick={() => meeleWeaponsToggler()}>Hide Melee Weapons</button>
                    : <button className='btn_melee_bp' onClick={() => meeleWeaponsToggler()}>Show Melee Weapons</button>
                  }
                </div>
                <Paginator pageAct={pageAct} setPageAct={setPageAct}/>
              </div>
            </div>
            <div className="inventory_items_container_bp">
                  {userAsset &&
                  <>
                      {userAsset.map((a)=> (
                          <div key={a.asset_id} className='item_box_bp'>
                            <WorkshopItems itemP={a} onSelect={itemSelector}/>
                          </div>
                      ))}
                  </>
                  }
              </div>
          </div>
            
        </div>
    )
  }

  return (
        <div className='inventory_main_container_blueprints'>
          <div className='inventory_modal_box'>
            <div className='header_container'>
              <div className='closer_title_row'>
                <h2 className='inventory_title_bp'>select {part}</h2>
                <button className='btn_ close' onClick={() => closer()}><FontAwesomeIcon icon={faXmark}/></button>
              </div>
              <div className='page_controllers_container_bp suits_bp'>
                <Paginator pageAct={pageAct} setPageAct={setPageAct}/>
              </div>
            </div>
            <div className="inventory_items_container_bp">
                  {userAsset &&
                  <>
                      {userAsset.map((a)=> (
                          <div key={a.asset_id} className='item_box_bp'>
                            <WorkshopItems itemP={a} onSelect={itemSelector}/>
                          </div>
                      ))}
                  </>
                  }
              </div>
          </div>  
        </div>
  )
}

export const InventoryHero = ({userData, action, closer,}) => {

  const [userAsset, setUserAsset] = useState();
  const [pageAct, setPageAct] = useState(1);
  const [loadingData, setLoadingData] = useState(true);
  
  const [fNation, setFNation] = useState(false);
  const [matchNation, setMatchNation] = useState();
  const [fRarity, setFRarity] = useState(false);
  const [matchRarity, setMatchRarity] = useState();
  
  const HERO_SCHEMA = 'suits';
  

  useEffect(() => {     
      
    loadAssets();

        return () => {
          //
      };

  }, [pageAct]);

  useEffect(() => {     
      
    loadAssets();

        return () => {
          setPageAct(1)
      };

  }, []);

  const loadAssets = async() => {
    if(fNation && fRarity){
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${HERO_SCHEMA}&owner=${userData.username}&page=${pageAct}&data.Nation=${matchNation}&data.Rarity=${matchRarity}&limit=6&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const assetsData = data.data;
      setUserAsset(assetsData);
    }
    else if(fRarity){
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${HERO_SCHEMA}&owner=${userData.username}&page=${pageAct}&data.Rarity=${matchRarity}&limit=6&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const assetsData = data.data;
      setUserAsset(assetsData);
    }else if(fNation){
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${HERO_SCHEMA}&owner=${userData.username}&page=${pageAct}&data.Nation=${matchNation}&limit=6&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const assetsData = data.data;
      setUserAsset(assetsData);
    }
    else{
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&schema_name=${HERO_SCHEMA}&owner=${userData.username}&page=${pageAct}&limit=6&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const assetsData = data.data;
      setUserAsset(assetsData);
    }
  }

  return (
        <div className='inventory_main_container_blueprints'>
        <div className='inventory_modal_box'>
          <div className='header_container'>
            <div className='closer_title_row'>
              <h2 className='inventory_title_bp'>select Hero</h2>
              <button className='btn_ close' onClick={() => closer()}><FontAwesomeIcon icon={faXmark}/></button>
            </div>
            <div className='page_controllers_container_bp'>
              <div className='filter_container_bp'>
                
              </div>
              <Paginator pageAct={pageAct} setPageAct={setPageAct}/>
            </div>
          </div>
          <div className="inventory_items_container_bp">
                {userAsset &&
                <>
                    {userAsset.map((a)=> (
                        <div key={a.asset_id} className='item_box_bp'>
                          <Heroes itemP={a} action={action}/>
                        </div>
                    ))}
                </>
                }
            </div>
        </div>
      </div>
  )
}

export const FurnaceInv = ({userData}) => {

  const [reloadInv, setReloadInv] = useState()
  const [userAsset, setUserAsset] = useState();
  const [pageAct, setPageAct] = useState(1);
  const [itemsSelected, setItemsSelected] = useState([])
  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: '',
    msg: '',
    txId: '',
  })

  const matchNation = 'Training Camp'; // CAMBIAR A MAINNET
  const matchStatus = 'Damaged';


  useEffect(() => {
    if(userData.isConnected){  
      loadAssets();

    }

    return () => {
      // Nothing to do
    };

  }, [pageAct, userData.isConnected]);

  useEffect(() => {
    if(userData.isConnected){  
      loadAssets();

    }

    return () => {
      setUserAsset([]);
    };

  }, [reloadInv]);

  const loadAssets = async() => {
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&owner=${userData.username}&page=${pageAct}&data.Nation=${matchNation}&mutable_data.Status=${matchStatus}&limit=20&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const assetsData = data.data;
      setUserAsset(assetsData);
  }

  const itemSelector = (itemId) => {
    const exist = itemsSelected.includes(itemId);

    if(Number(itemsSelected.length) < 10){
      if(!exist){
        const newItem = itemId;
        setItemsSelected([...itemsSelected, newItem])
      }
      else {
        const items = [...itemsSelected].filter(x => x !== itemId);
        setItemsSelected(items);
      }
    }else{
      if(exist){
        const items = [...itemsSelected].filter(x => x !== itemId);
        setItemsSelected(items);
      }
      //console.log('max item')
    }
  }

  const burnItems = async() => {
    if(userData.whichProvider === 'Anchor'){
      try{
        let actions = [];
        for (let index = 0; index < itemsSelected.length; index++) {
          const action = {
            account: 'atomicassets',
            name: 'transfer',
            authorization: [userData.auths],
            data: {
              from: userData.username,
              to: ExtinctionData.EXTINCTION_CONTRACT,
              asset_ids: [itemsSelected[index]],
              memo: `Burn It Down`,
            },            
          }
          actions = [...actions, action];
        }   
          
        userData.sessionData.transact({actions}).then(({transaction}) => {
          clearSelections();
          setTimeout(() => {
            setReloadInv(transaction.id.toString())
          }, 500);
        })
      }catch(err){

      }
    }
    else if(userData.whichProvider === 'WaxCloud'){
        try{
          let actionsWC = {};
          let actions =[];
          for (let index = 0; index < itemsSelected.length; index++) {
            const action = {
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                  }],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    asset_ids: [itemsSelected[index]],
                    memo: `Burn It Down`,
                  },
            }   
            actions = [...actions, action];
          };
          actionsWC = {
            actions: actions,
          }
          const transaction = await userData.sessionData.api.transact(actionsWC, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            clearSelections();
            setTimeout(() => {
              setReloadInv(transaction.transaction_id)
            }, 500);

          }
          catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
          }
    }
  }

  const clearSelections = () => setItemsSelected([]);

  const items = {
    visible: x => ({
      opacity: 1,
      y: 0,
      transition: { delay: x * 0.2, duration: 0.2 },
    }),
    initial: {
      y: '100px',
      opacity: 0,
    }
  }
  
  return(
    <div className='inv_container'>
      {nofity.status && 
        <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
          <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>
        </div>
      }
          <div className='top-controls-inv-selector'>
            <div className='controls-section'>
                <div className="page-container">
                  {pageAct > 1 &&
                    <button onClick={() => setPageAct(pageAct - 1)} className='btn-page'>Prev Page</button>            
                  }
                  <span className='page-ident'>{pageAct}</span>
                  <button onClick={() => setPageAct(pageAct + 1)} className='btn-page'>Next Page</button>
                </div>
                {(Number(itemsSelected.length) > 0) &&
                  <div className=''>
                  <motion.button onClick={() => clearSelections()}
                  >Unselect {Number(itemsSelected.length) > 1 ? 'All' : ''}</motion.button>
                  <motion.button
                  onClick={() => burnItems()}
                  >Destroy</motion.button>
                </div>
                }
            </div>
          </div>
          <div className='section-items'>
              {userAsset &&
              <>
                  {userAsset.map((a, x)=> (
                    <motion.div className='asset-box card-asset' style={{position: 'relative'}} key={a.asset_id}
                    custom={x}
                    initial='initial'
                    animate='visible'
                    variants={items}
                    >
                      {(itemsSelected.includes(a.asset_id))
                      ?<motion.button onClick={() => itemSelector(a.asset_id)} className='btn_selector_multi'
                      whileHover={{ scale: 1.2, color: '#bdbdbd', duration: 0.2 }}
                      whileTap={{ scale: 0.5, duration: 0.2}}
                      ><FontAwesomeIcon icon={faCircleCheck} size='xl'/></motion.button>
                      :<motion.button onClick={() => itemSelector(a.asset_id)} className='btn_selector_multi'
                      whileHover={{ scale: 1.2, color: '#bdbdbd', duration: 0.2}}
                      whileTap={{ scale: 0.5, duration: 0.2}}
                      ><FontAwesomeIcon icon={faCircleDot} size='xl'/></motion.button>
                    }
                      <ItemsInv itemP={a}/>
                    </motion.div>
                  ))}
              </>
              }
          </div>
      </div>
  )
}